// src/data/servicesData.js

import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import CodeIcon from "@mui/icons-material/Code";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import HubIcon from "@mui/icons-material/Hub";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import SecurityIcon from "@mui/icons-material/Security";
import ApartmentIcon from "@mui/icons-material/Apartment";
import SpeedIcon from "@mui/icons-material/Speed";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import GroupsIcon from "@mui/icons-material/Groups";
import InsightsIcon from "@mui/icons-material/Insights";
import StorageIcon from "@mui/icons-material/Storage";
import DevicesIcon from "@mui/icons-material/Devices";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import LightbulbIcon from "@mui/icons-material/Lightbulb";

export const servicesData = {
  "sap-consulting-implementation": {
    title: "SAP Consulting & Implementation",
    subtitle:
      "Accelerate your digital transformation with our comprehensive SAP implementation services tailored to your business needs.",
    label: "Services Include",
    icon: SettingsSuggestIcon,
    image: "/images/services/sap-consulting.jpg",
    accent: "#0755c9",

    seo: {
      title:
        "SAP Consulting & Implementation Services in Saudi Arabia | ZENCON",
      description:
        "ZENCON provides SAP consulting, SAP S/4HANA implementation, SAP ECC migration, SAP integration, and enterprise digital transformation services in Saudi Arabia.",
      keywords:
        "SAP consulting Saudi Arabia, SAP implementation, SAP S4HANA, SAP ECC migration, SAP ERP services, enterprise SAP solutions, ZENCON",
      image: "https://www.zencon-sa.com/images/services/sap-consulting.jpg",
    },

    servicesInclude: [
      "SAP S/4HANA Implementation",
      "SAP ECC Migration",
      "Greenfield & Brownfield Projects",
      "SAP Rollouts",
      "SAP System Integration",
      "SAP Business Process Optimization",
    ],

    offers: [
      "Enterprise SAP transformation strategy",
      "Business process re-engineering",
      "SAP architecture and deployment planning",
      "Secure data migration and validation",
    ],

    why: [
      "Accelerated digital transformation delivery",
      "Industry-aligned SAP implementation frameworks",
      "Reduced deployment risks and downtime",
      "Scalable enterprise-ready SAP environments",
    ],
    whyIcons: [RocketLaunchIcon, FactCheckIcon, SecurityIcon, ApartmentIcon],

    process: [
      "Business Assessment",
      "Solution Architecture",
      "Implementation & Integration",
      "Testing, Go-Live & Optimization",
    ],

    detailedSections: [
      {
        title: "SAP S/4HANA Implementation",
        description:
          "We deliver SAP S/4HANA implementation services that help enterprises modernize core operations, improve business agility, and establish a scalable digital foundation for long-term growth.",
      },
      {
        title: "SAP ECC Migration",
        description:
          "We support secure and structured migration from SAP ECC to modern SAP environments while protecting critical business data and minimizing operational disruption.",
      },
      {
        title: "Greenfield & Brownfield Projects",
        description:
          "Our SAP experts manage both Greenfield and Brownfield implementation models, enabling organizations to launch new SAP landscapes or optimize existing systems with confidence.",
      },
      {
        title: "SAP Rollouts & Integration",
        description:
          "We execute controlled SAP rollouts and system integrations that standardize operations, connect enterprise platforms, and improve cross-functional data visibility.",
      },
      {
        title: "SAP Business Process Optimization",
        description:
          "We optimize SAP-enabled business processes to reduce complexity, improve productivity, and align system performance with strategic business objectives.",
      },
    ],
  },

  "sap-support-managed-services": {
    title: "SAP Support & Managed Services",
    subtitle:
      "Ensure uninterrupted business operations with proactive SAP support and maintenance services.",
    label: "We Provide",
    icon: SupportAgentIcon,
    image: "/images/services/sap-support.jpg",
    accent: "#0755c9",

    seo: {
      title: "SAP Support & Managed Services in Saudi Arabia | ZENCON",
      description:
        "Professional SAP support and managed services including SAP monitoring, SAP maintenance, performance optimization, and enterprise SAP support solutions.",
      keywords:
        "SAP support Saudi Arabia, SAP managed services, SAP maintenance, SAP monitoring, SAP technical support, SAP functional support",
      image: "https://www.zencon-sa.com/images/services/sap-support.jpg",
    },

    servicesInclude: [
      "24/7 SAP Support",
      "Application Management Services",
      "System Monitoring",
      "Performance Optimization",
      "SAP Security & Compliance",
      "Functional & Technical Support",
    ],

    offers: [
      "24/7 enterprise SAP monitoring",
      "SAP application lifecycle management",
      "Performance and security optimization",
      "Functional and technical support services",
    ],

    why: [
      "Maximum SAP system availability",
      "Rapid incident response and resolution",
      "Continuous performance optimization",
      "Reliable enterprise support operations",
    ],

    whyIcons: [CloudDoneIcon, SpeedIcon, QueryStatsIcon, SupportAgentIcon],

    process: [
      "System Monitoring",
      "Incident Resolution",
      "Performance Optimization",
      "Continuous Support Management",
    ],

    detailedSections: [
      {
        title: "24/7 SAP Support",
        description:
          "Our dedicated SAP support services help maintain business continuity through round-the-clock assistance, fast issue resolution, and proactive system care.",
      },
      {
        title: "Application Management Services",
        description:
          "We provide structured application management services covering enhancements, configuration support, user assistance, and continuous improvement.",
      },
      {
        title: "System Monitoring & Performance Optimization",
        description:
          "We monitor SAP environments to identify potential risks early, optimize performance, and maintain stable system operations.",
      },
      {
        title: "SAP Security & Compliance",
        description:
          "Our support framework includes security reviews, access control support, compliance alignment, and governance-focused SAP administration.",
      },
      {
        title: "Functional & Technical Support",
        description:
          "We provide expert functional and technical support across SAP modules, helping users resolve business and system-related issues efficiently.",
      },
    ],
  },

  "sap-upgrade-migration-services": {
    title: "SAP Upgrade & Migration Services",
    subtitle:
      "Modernize your enterprise systems with smooth and secure SAP upgrades and migrations.",
    label: "Expertise",
    icon: UpgradeIcon,
    image: "/images/services/sap-upgrade.jpg",
    accent: "#0755c9",

    seo: {
      title: "SAP Upgrade & Migration Services in Saudi Arabia | ZENCON",
      description:
        "Secure SAP upgrade and migration services including SAP S/4HANA migration, cloud migration, database migration, and SAP landscape optimization.",
      keywords:
        "SAP migration Saudi Arabia, SAP upgrade services, SAP S4HANA migration, SAP cloud migration, SAP landscape optimization",
      image: "https://www.zencon-sa.com/images/services/sap-upgrade.jpg",
    },

    servicesInclude: [
      "SAP S/4HANA Migration",
      "SAP Upgrade Services",
      "Cloud Migration",
      "Database Migration",
      "SAP Landscape Optimization",
    ],

    offers: [
      "SAP modernization and transformation",
      "Cloud and infrastructure migration",
      "Database and landscape optimization",
      "Secure enterprise migration planning",
    ],

    why: [
      "Smooth and secure system transitions",
      "Reduced migration risks",
      "Improved performance and scalability",
      "Future-ready SAP infrastructure",
    ],

    whyIcons: [SyncAltIcon, SecurityIcon, TrendingUpIcon, CloudQueueIcon],

    process: [
      "Infrastructure Assessment",
      "Migration Strategy",
      "Upgrade Execution",
      "Validation & Stabilization",
    ],

    detailedSections: [
      {
        title: "SAP S/4HANA Migration",
        description:
          "We support enterprises in migrating to SAP S/4HANA with secure planning, controlled execution, and minimal disruption to business operations.",
      },
      {
        title: "SAP Upgrade Services",
        description:
          "Our upgrade services help organizations enhance SAP system performance, improve security, and unlock new capabilities through structured version upgrades.",
      },
      {
        title: "Cloud Migration",
        description:
          "We help move enterprise workloads to secure cloud environments while maintaining performance, availability, and business continuity.",
      },
      {
        title: "Database Migration",
        description:
          "Our database migration services ensure smooth transition, data integrity, and optimized performance across modern database platforms.",
      },
      {
        title: "SAP Landscape Optimization",
        description:
          "We simplify and optimize SAP landscapes to improve scalability, reduce technical complexity, and enhance operational efficiency.",
      },
    ],
  },

  "digital-transformation": {
    title: "Digital Transformation",
    subtitle:
      "Empower your business with modern technologies and intelligent digital solutions.",
    label: "Solutions",
    icon: AutoAwesomeIcon,
    image: "/images/services/digital-transformation.jpg",
    accent: "#0755c9",

    seo: {
      title: "Digital Transformation Services in Saudi Arabia | ZENCON",
      description:
        "Enterprise digital transformation solutions including workflow automation, intelligent reporting, process digitization, and modern workplace solutions.",
      keywords:
        "digital transformation Saudi Arabia, workflow automation, business digitization, enterprise automation, intelligent reporting",
      image:
        "https://www.zencon-sa.com/images/services/digital-transformation.jpg",
    },

    servicesInclude: [
      "Enterprise Automation",
      "Business Process Digitization",
      "Workflow Automation",
      "Intelligent Reporting",
      "Digital Workplace Solutions",
    ],

    offers: [
      "Enterprise workflow automation",
      "Digital business transformation",
      "Intelligent operational reporting",
      "Modern workplace enablement",
    ],

    why: [
      "Improved operational efficiency",
      "Enhanced enterprise collaboration",
      "Accelerated digital adoption",
      "Data-driven business operations",
    ],

    whyIcons: [SpeedIcon, GroupsIcon, RocketLaunchIcon, InsightsIcon],

    process: [
      "Digital Strategy Assessment",
      "Transformation Planning",
      "Solution Deployment",
      "Continuous Optimization",
    ],

    detailedSections: [
      {
        title: "Enterprise Automation",
        description:
          "We automate repetitive business activities to improve speed, accuracy, and operational consistency across enterprise functions.",
      },
      {
        title: "Business Process Digitization",
        description:
          "We convert manual and traditional business processes into modern digital workflows that improve visibility, control, and productivity.",
      },
      {
        title: "Workflow Automation",
        description:
          "Our workflow automation solutions streamline approvals, notifications, task routing, and operational processes across departments.",
      },
      {
        title: "Intelligent Reporting",
        description:
          "We develop intelligent reporting solutions that provide real-time insights, performance visibility, and better decision-making support.",
      },
      {
        title: "Digital Workplace Solutions",
        description:
          "We build connected workplace solutions that improve collaboration, accessibility, and productivity across modern organizations.",
      },
    ],
  },

  "cloud-services": {
    title: "Cloud Services",
    subtitle: "Build scalable, secure, and future-ready cloud infrastructure.",
    label: "Cloud Capabilities",
    icon: CloudQueueIcon,
    image: "/images/services/cloud-services.jpg",
    accent: "#0755c9",

    seo: {
      title: "Enterprise Cloud Services in Saudi Arabia | ZENCON",
      description:
        "Secure and scalable cloud services including SAP on cloud, AWS, Azure, hybrid cloud solutions, cloud security, and infrastructure management.",
      keywords:
        "cloud services Saudi Arabia, SAP cloud services, AWS services, Azure services, hybrid cloud, cloud infrastructure",
      image: "https://www.zencon-sa.com/images/services/cloud-services.jpg",
    },

    servicesInclude: [
      "SAP on Cloud",
      "AWS & Azure Services",
      "Cloud Infrastructure Management",
      "Hybrid Cloud Solutions",
      "Cloud Security & Backup",
    ],

    offers: [
      "Enterprise cloud transformation",
      "Hybrid and multi-cloud infrastructure",
      "Cloud governance and security",
      "Backup and disaster recovery solutions",
    ],

    why: [
      "Scalable and secure cloud operations",
      "Improved business continuity",
      "Optimized infrastructure performance",
      "Flexible enterprise cloud environments",
    ],

    whyIcons: [CloudDoneIcon, SecurityIcon, QueryStatsIcon, StorageIcon],

    process: [
      "Cloud Readiness Assessment",
      "Architecture & Migration Planning",
      "Cloud Deployment",
      "Optimization & Governance",
    ],

    detailedSections: [
      {
        title: "SAP on Cloud",
        description:
          "We help organizations deploy, migrate, and manage SAP environments on secure and scalable cloud platforms.",
      },
      {
        title: "AWS & Azure Services",
        description:
          "Our cloud specialists design and manage AWS and Azure environments aligned with enterprise performance, security, and scalability needs.",
      },
      {
        title: "Cloud Infrastructure Management",
        description:
          "We manage cloud infrastructure operations, monitoring, optimization, and governance to support reliable business performance.",
      },
      {
        title: "Hybrid Cloud Solutions",
        description:
          "We design hybrid cloud environments that connect on-premise systems with cloud platforms while maintaining flexibility and control.",
      },
      {
        title: "Cloud Security & Backup",
        description:
          "We implement enterprise-grade cloud security, backup, and disaster recovery solutions to protect critical business operations.",
      },
    ],
  },

  "custom-application-development": {
    title: "Custom Application Development",
    subtitle:
      "Develop scalable and user-friendly enterprise applications tailored to your business operations.",
    label: "Development Services",
    icon: CodeIcon,
    image: "/images/services/custom-development.jpg",
    accent: "#0755c9",

    seo: {
      title: "Custom Application Development Services | ZENCON",
      description:
        "Professional web application development, mobile app development, enterprise portals, API development, and custom dashboard solutions.",
      keywords:
        "custom application development, web application development, enterprise portals, API development, mobile app development",
      image: "https://www.zencon-sa.com/images/services/custom-development.jpg",
    },

    servicesInclude: [
      "Web Application Development",
      "Mobile App Development",
      "Enterprise Portals",
      "API Development",
      "Custom Dashboards",
    ],

    offers: [
      "Enterprise-grade web applications",
      "Cross-platform mobile solutions",
      "API and system integration",
      "Custom reporting dashboards",
    ],

    why: [
      "Scalable application architecture",
      "Modern and intuitive user experiences",
      "Seamless enterprise integration",
      "Business-focused application design",
    ],

    whyIcons: [ApartmentIcon, DevicesIcon, SyncAltIcon, LightbulbIcon],

    process: [
      "Requirement Discovery",
      "UI/UX & Architecture Design",
      "Application Development",
      "Testing & Deployment",
    ],

    detailedSections: [
      {
        title: "Web Application Development",
        description:
          "We develop secure, scalable, and responsive web applications tailored to enterprise workflows and business requirements.",
      },
      {
        title: "Mobile App Development",
        description:
          "Our mobile application solutions deliver intuitive digital experiences for employees, customers, and business users across devices.",
      },
      {
        title: "Enterprise Portals",
        description:
          "We build enterprise portals that centralize access to systems, information, workflows, and business services.",
      },
      {
        title: "API Development",
        description:
          "We design and develop secure APIs that connect applications, enable automation, and support seamless enterprise integration.",
      },
      {
        title: "Custom Dashboards",
        description:
          "We create custom dashboards that provide real-time visibility into business performance, KPIs, and operational data.",
      },
    ],
  },

  "data-analytics-business-intelligence": {
    title: "Data Analytics & Business Intelligence",
    subtitle:
      "Transform data into actionable insights for better business decisions.",
    label: "Solutions",
    icon: BusinessCenterIcon,
    image: "/images/services/analytics.jpg",
    accent: "#0755c9",

    seo: {
      title: "Data Analytics & Business Intelligence Services | ZENCON",
      description:
        "Advanced data analytics and business intelligence solutions including SAP Analytics Cloud, Power BI dashboards, KPI reporting, and predictive analytics.",
      keywords:
        "business intelligence Saudi Arabia, SAP Analytics Cloud, Power BI services, KPI dashboards, predictive analytics",
      image: "https://www.zencon-sa.com/images/services/analytics.jpg",
    },

    servicesInclude: [
      "SAP Analytics Cloud",
      "Power BI",
      "Real-Time Reporting",
      "KPI Dashboards",
      "Predictive Analytics",
    ],

    offers: [
      "Real-time business intelligence",
      "Executive KPI dashboards",
      "Advanced analytics solutions",
      "Predictive business insights",
    ],

    why: [
      "Improved strategic decision-making",
      "Real-time operational visibility",
      "Actionable business intelligence",
      "Enhanced reporting accuracy",
    ],

    whyIcons: [InsightsIcon, QueryStatsIcon, LightbulbIcon, FactCheckIcon],

    process: [
      "Data Assessment",
      "Analytics Strategy",
      "Dashboard Development",
      "Reporting Optimization",
    ],

    detailedSections: [
      {
        title: "SAP Analytics Cloud",
        description:
          "We help organizations use SAP Analytics Cloud to create intelligent planning, reporting, and analytics solutions for enterprise decision-making.",
      },
      {
        title: "Power BI",
        description:
          "We develop Power BI dashboards and reports that turn complex business data into clear, interactive, and actionable insights.",
      },
      {
        title: "Real-Time Reporting",
        description:
          "Our real-time reporting solutions improve operational visibility and help decision-makers respond faster to business changes.",
      },
      {
        title: "KPI Dashboards",
        description:
          "We design executive KPI dashboards that track performance, highlight trends, and support strategic business management.",
      },
      {
        title: "Predictive Analytics",
        description:
          "We apply predictive analytics to identify patterns, improve forecasting, and support proactive business planning.",
      },
    ],
  },

  "ai-iot-intelligent-automation": {
    title: "AI, IoT & Intelligent Automation",
    subtitle: "Drive operational efficiency through smart technologies.",
    label: "Innovation Services",
    icon: HubIcon,
    image: "/images/services/ai-iot.jpg",
    accent: "#0755c9",

    seo: {
      title: "AI, IoT & Intelligent Automation Services | ZENCON",
      description:
        "AI-powered enterprise solutions, IoT integration, robotic process automation, machine learning, and intelligent automation services.",
      keywords:
        "AI solutions Saudi Arabia, IoT integration, intelligent automation, RPA services, machine learning solutions",
      image: "https://www.zencon-sa.com/images/services/ai-iot.jpg",
    },

    servicesInclude: [
      "AI-Powered Solutions",
      "IoT Integration",
      "Robotic Process Automation (RPA)",
      "Machine Learning Solutions",
      "Smart Manufacturing",
    ],

    offers: [
      "AI-powered enterprise solutions",
      "Industrial IoT integration",
      "Robotic process automation",
      "Machine learning and smart operations",
    ],

    why: [
      "Improved operational intelligence",
      "Higher automation efficiency",
      "Reduced manual intervention",
      "Future-ready enterprise innovation",
    ],

    whyIcons: [InsightsIcon, AutoAwesomeIcon, SpeedIcon, HubIcon],

    process: [
      "Innovation Discovery",
      "Use Case Development",
      "Technology Implementation",
      "Continuous Enhancement",
    ],

    detailedSections: [
      {
        title: "AI-Powered Solutions",
        description:
          "We develop AI-powered solutions that improve decision-making, automate business processes, and enhance enterprise productivity.",
      },
      {
        title: "IoT Integration",
        description:
          "Our IoT integration services connect devices, assets, and enterprise systems to enable real-time monitoring and operational intelligence.",
      },
      {
        title: "Robotic Process Automation",
        description:
          "We implement RPA solutions that automate repetitive tasks, reduce manual effort, and improve process accuracy.",
      },
      {
        title: "Machine Learning Solutions",
        description:
          "We build machine learning solutions that help organizations identify patterns, forecast outcomes, and optimize business performance.",
      },
      {
        title: "Smart Manufacturing",
        description:
          "We support smart manufacturing initiatives through connected systems, intelligent monitoring, automation, and data-driven production insights.",
      },
    ],
  },
};
